import { createFileRoute, useSearch } from "@tanstack/react-router";
import { DehydratedState, hydrate, useQueryClient, useQuery, dehydrate } from "@tanstack/react-query";
import { businessCategoryQueryOptions } from "@/server/business-directory";
import { CategoryForm } from "../-components/category-form";
import { CategoryReadable } from "@/lib/mma/types.gen";
import { Card, CardContent } from "@/components/ui/card";

export const Route = createFileRoute("/_dashboard/business-directory/categories")({
  component: RouteComponent,
  validateSearch: (search: Record<string, unknown>) => {
    const id = search.id as number | string | undefined;
    return { id };
  },
  loaderDeps: ({ search }) => {
    return { id: search.id };
  },
  loader: async ({ context, deps }) => {
    const { id } = deps;

    if (id === "new") {
      return {
        crumb: "New Category",
      };
    } else if (id) {
      try {
        const queryOptions = businessCategoryQueryOptions(id as number);
        await context.queryClient.prefetchQuery(queryOptions);
        const categoryData = context.queryClient.getQueryData(queryOptions.queryKey) as CategoryReadable | undefined;
        return {
          crumb: categoryData?.name || `Category ${id}`,
          dehydratedState: dehydrate(context.queryClient) as any,
        };
      } catch (error) {
        return {
          crumb: `Category ${id}`,
        };
      }
    }

    return {
      crumb: "Categories",
    };
  },
});

function RouteComponent() {
  const { dehydratedState } = Route.useLoaderData() as { dehydratedState: DehydratedState };
  const queryClient = useQueryClient();
  hydrate(queryClient, dehydratedState);
  const search = useSearch({ from: "/_dashboard/business-directory/categories" });
  const isNew = search.id === "new";

  const categoryQuery = useQuery(businessCategoryQueryOptions(typeof search.id === "number" ? search.id : 0));

  const category = categoryQuery.data;

  if (!category?.id && !isNew) {
    return (
      <Card>
        <CardContent>
          <p className="text-md pb-20 pt-15 text-center">Please select a category to view its details.</p>
        </CardContent>
      </Card>
    );
  }
  return <CategoryForm category={category as CategoryReadable} isEdit={!isNew} />;
}
